// Shared admin enum option/label maps — single source of truth so consoles
// don't each redeclare SUBJECTS / PRODUCT_LABEL / PAYMENT / attempt modes.

export const SUBJECTS = [{ v: 0, l: "Fyzika" }, { v: 1, l: "Chemie" }, { v: 2, l: "Biologie" }];
export const SUBJECT_LABEL: { [k: number]: string } = { 0: "Fyzika", 1: "Chemie", 2: "Biologie" };

export const PRODUCTS = [
    { v: 0, l: "Samostudium" },
    { v: 1, l: "Kurz s lektorem" },
    { v: 2, l: "Individuální lekce" },
    { v: 3, l: "Hodiny navíc" },
];
export const PRODUCT_LABEL: { [k: number]: string } = { 0: "Samostudium", 1: "Kurz s lektorem", 2: "Individuální", 3: "Hodiny navíc" };

export const PAYMENT = [{ v: 0, l: "Jednorázově" }, { v: 1, l: "Dvě platby" }, { v: 2, l: "Měsíčně" }];
export const PAYMENT_LABEL: { [k: number]: string } = { 0: "Jednorázově", 1: "Dvě platby", 2: "Měsíčně" };

export const ATTEMPT_MODE: { [k: number]: string } = { 0: "Kvíz lekce", 1: "Volný test", 2: "Modelový test" };

// Question types — must match QuestionTypes enum (Single=0, Multiple=1, NoneCorrect=2).
export const QTYPES = [{ v: 0, l: "Jedna správná" }, { v: 1, l: "Více správných" }, { v: 2, l: "Žádná není správná" }];
export const QTYPE_LABEL: { [k: number]: string } = { 0: "Jedna", 1: "Více", 2: "Žádná" };

// Question review status — must match QuestionStatus enum (Unverified=0, Approved=1, Rejected=2).
export const QSTATUS = [{ v: 0, l: "Neověřeno" }, { v: 1, l: "Schváleno" }, { v: 2, l: "Zamítnuto" }];
export const QSTATUS_LABEL: { [k: number]: string } = { 0: "Neověřeno", 1: "Schváleno", 2: "Zamítnuto" };
// CSS class for the status badge in tables (reuses .tag / .ok / .no).
export const QSTATUS_CLASS: { [k: number]: string } = { 0: "tag", 1: "ok", 2: "no" };
export const NONE_OPTION_ID = "ffffffff-ffff-ffff-ffff-ffffffffffff";
